import AppRoutePath from "../../../../router/AppRoutePath";

export const paymentType = [
  // { label: "Installment", value: "installment" },
  { label: "Balloon Payment", value: "balloon_payment" },
];

export const tenorType = [
  { label: "Reguler", value: "reguler" },
  { label: "Non Regular", value: "non_reguler" },
];

export const pawnType = [
  { label: "Reguler", value: "reguler" },
  { label: "Jemput Gadai", value: "pick_up" },
];

export const dataBreadcrumb = [
  { label: "Reguler Offer", route: AppRoutePath.CAMPAIGN_DEFAULT },
  { label: "Pinjaman Balloon Payment / Edit Reguler Offer Pinjaman Balloon Payment", route: null },
];
